import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import CopyLabel from 'akasia-components/servicio/CopyLabel';
import ModalActualizarDatosFiscalesCliente from './ModalActualizarDatosCliente';


const SeccionDatosFiscales = ({
    loadingInfoDetallesOrden,
    orden,
    setOrden,
    GuardarComentario,
    onComentarioAgregado,
    ObtenerComentariosOrden
}) => {

    const [showModalActualizarDatos, setShowModalActualizarDatos] = useState(false);
    const [linkValidarNumRegTrib, setLinkValidarNumRegTrib] = useState('');

    const crearLinkValidarNumRegTrib = (vPais) => {

        console.log("vPais: ", vPais);
        if (vPais == "MÉXICO") {
            setLinkValidarNumRegTrib(" https://agsc.siat.sat.gob.mx/PTSC/ValidaRFC/index.jsf");
        } else if (vPais == "HONDURAS") {
            setLinkValidarNumRegTrib("https://www.sar.gob.hn/consulta-rtn/");
        } else if (vPais == "REPÚBLICA DOMINICANA") {
            setLinkValidarNumRegTrib("https://www.dgii.gov.do/app/WebApps/ConsultasWeb/consultas/rnc.aspx");
        } else if (vPais == "GUATEMALA") {
            setLinkValidarNumRegTrib("https://portal.sat.gob.gt/portal/consulta-cui-nit/");
        } else if (vPais == "COLOMBIA") {
            setLinkValidarNumRegTrib("https://muisca.dian.gov.co/WebRutMuisca/DefConsultaEstadoRUT.faces");
        } else if (vPais == "ECUADOR") {
            setLinkValidarNumRegTrib("https://srienlinea.sri.gob.ec/sri-en-linea/SriRucWeb/ConsultaRuc/Consultas/consultaRuc");
        } else if (vPais == "PERÚ") {
            setLinkValidarNumRegTrib("https://e-consultaruc.sunat.gob.pe/cl-ti-itmrconsruc/FrameCriterioBusquedaWeb.jsp");
        } else if (vPais == "BOLIVIA") {
            setLinkValidarNumRegTrib("https://ov.impuestos.gob.bo/");
        } else if (vPais == "ARGENTINA") {
            setLinkValidarNumRegTrib("https://servicioscf.afip.gob.ar/publico/crmcit/consulta.aspx");
        } else if (vPais == "CHILE") {
            setLinkValidarNumRegTrib("https://zeus.sii.cl/cvc/stc/stc.html");
        } else if (vPais == "COSTA RICA") {
            setLinkValidarNumRegTrib("https://atv.hacienda.go.cr/ATV/frmConsultaSituTributaria.aspx");
        } else {
            setLinkValidarNumRegTrib("");
        }
    };

    useEffect(() => {
        crearLinkValidarNumRegTrib(orden.vPais);
    }, [orden])


    return (
        loadingInfoDetallesOrden ? <Skeleton width={300} count={5} /> :
            <>

                <h5 className="mb-3 fs-0">Datos de facturaci&oacute;n</h5>
                <hr></hr>
                <Button variant="outline-primary" onClick={() => setShowModalActualizarDatos(true)}>Actualizar Datos Fiscales</Button>
                <hr></hr>
                {/*<h6 className="mb-2"><strong>{orden.vRfc}</strong></h6>*/}
                {
                    <h6 className="mb-2 p-0">
                        {
                            orden.vPais == 'MÉXICO' ?
                                <>
                                    <CopyLabel code={orden.vRfc} placement={"left"} padding="0px" />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip style={{ position: 'fixed' }} >
                                                Validar
                                            </Tooltip>
                                        }
                                    >
                                        <a href={linkValidarNumRegTrib} target="_blank" rel="noopener noreferrer">
                                            <img width="25" src="/img/validar96.png"></img>
                                        </a>
                                    </OverlayTrigger>
                                </>
                                :
                                <>
                                    <strong>{orden.vRfc}</strong>
                                </>
                        }
                    </h6>
                }
                {
                    orden.vNumRegTrib &&
                    <h6 className="mb-2">
                        <CopyLabel code={orden.vNumRegTrib} placement="top" padding="0px" />
                        {
                            linkValidarNumRegTrib && /*Si el state esta vacio significa que no tenemos un link para validar el NumRegTRib de ese pais */
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip style={{ position: 'fixed' }} >
                                        Validar
                                    </Tooltip>
                                }
                            >
                                 <a href={linkValidarNumRegTrib} target="_blank" rel="noopener noreferrer">
                                    <img width="25" src="/img/validar96.png"></img>
                                </a>
                            </OverlayTrigger>
                            }
                            
                    </h6>
                }
                
                <h6 className="mb-2">{orden.vRazonSocial}</h6>
                <p className="mb-0 fs--1">
                    {orden.vDireccionFiscal} CP: {orden.vCp}
                </p>
                <p className="mb-0 fs--1">CÓD. PAÍS: |{orden.vPaisFacturacion ?
                    <span>{orden.vPaisFacturacion}</span> :
                    orden.vRfc != 'XEXX010101000' ?
                        <span className="badge badge-soft-success">
                            <img src="/img/bandera-mexico-48.png" width="20"></img> MEXICANO</span> :
                        <span className="badge badge-soft-warning">Incompleto</span>}|
                </p >
                <p className="mb-0 fs--1">
                    {orden.vCodigoUso}  {orden.vDescripcionUsoCFDI}
                </p>
                <p className="mb-0 fs--1">
                    {orden.vCodigoRegimen}  {orden.vDescripcionRegimenFiscal}
                </p>

                {orden.vEmailFacturacion &&
                    <p className="mb-0 fs--1">
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip style={{ position: 'fixed' }} >
                                    Enviar correo
                                </Tooltip>
                            }
                        >
                            <a href={"mailto:" + orden.vEmailFacturacion}>
                                <img width="25" src="/img/correo96.png"></img>
                            </a>
                        </OverlayTrigger>
                        <CopyLabel
                            code={orden.vEmailFacturacion}
                            placement={"right"}
                            padding="5px"
                        />
                    </p>
                }

                {orden.vTelefonoFacturacion &&
                    <p className="mb-0 fs--1">
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip style={{ position: 'fixed' }} >
                                    Enviar whatsapp
                                </Tooltip>
                            }
                        >
                            <a href={"https://wa.me/" + orden.vTelefonoFacturacion} target="_blank" rel="noreferrer">
                                <img width="25" src="/img/whatsapp40.png"></img>
                            </a>
                        </OverlayTrigger>
                        <CopyLabel
                            code={orden.vTelefonoFacturacion}
                            placement={"right"}
                            padding="5px"
                        />
                    </p>
                }


                <ModalActualizarDatosFiscalesCliente
                    setShowModalActualizarDatos={setShowModalActualizarDatos}
                    showModalActualizarDatos={showModalActualizarDatos}
                    objDatosFiscales={orden}
                    setObjDatosFiscales={setOrden}                  
                    idSource={2}
                    GuardarComentario={GuardarComentario}
                    onComentarioAgregado={onComentarioAgregado}
                    ObtenerComentariosOrden={ObtenerComentariosOrden}
                ></ModalActualizarDatosFiscalesCliente>


            </>

    )
}

SeccionDatosFiscales.propTypes = {
    loadingInfoDetallesOrden: PropTypes.bool,
    setOrden: PropTypes.func,
    orden: PropTypes.object,
    GuardarComentario: PropTypes.func,
    onComentarioAgregado: PropTypes.func,
    ObtenerComentariosOrden: PropTypes.func
};

export default SeccionDatosFiscales;